import { render } from "./componentTitleRu.vue?vue&type=template&id=090c449a&scoped=true&ts=true"
import script from "./componentTitleRu.vue?vue&type=script&lang=ts"
export * from "./componentTitleRu.vue?vue&type=script&lang=ts"

import "./componentTitleRu.vue?vue&type=style&index=0&id=090c449a&scoped=true&lang=less"

import exportComponent from "/workspace/source-code/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-090c449a"]])

export default __exports__